module.exports = __webpack_public_path__ + "media/images/haircut/sabrina@3x-15e3e16d51c5f68680c8abfff4987c89.jpg";